import { render, staticRenderFns } from "./UserBillingHistory.vue?vue&type=template&id=11d18f2d&scoped=true&"
import script from "./UserBillingHistory.vue?vue&type=script&lang=js&"
export * from "./UserBillingHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserBillingHistory.vue?vue&type=style&index=0&id=11d18f2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d18f2d",
  null
  
)

export default component.exports